import './SingleStepCard.css';
import React from 'react';
import { SitecoreContextReactContext } from '../../../utils/SitecoreContextReactContext';
import { Link } from '@sitecore-jss/sitecore-jss-react';
import { Text, RichText } from '@sitecore-jss/sitecore-jss-react';
import { ReactComponent as ChevronRight } from '../../../resources/icons/IconChevronRightLight.svg';
import { ReactComponent as ChevronLeft } from '../../../resources/icons/IconChevronLeftLight.svg';
export const SingleStepCard = props => {
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("article", {
    className: "step-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "step-card__header-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "step-card__num"
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "span",
    field: props.num
  })), /*#__PURE__*/React.createElement(Text, {
    className: "step-card__title",
    tag: "h1",
    field: props.title
  })), /*#__PURE__*/React.createElement(RichText, {
    tag: "div",
    className: "step-card__description",
    field: props.description
  }), props.link.value.href && props.ctaText && props.ctaText.value && /*#__PURE__*/React.createElement(Link, {
    className: "step-card__link",
    field: props.link,
    onClick: props.onLinkClick
  }, props.ctaText.value, rtl ? /*#__PURE__*/React.createElement(ChevronLeft, {
    className: "btn-link__icon"
  }) : /*#__PURE__*/React.createElement(ChevronRight, {
    className: "btn-link__icon"
  }))));
};
const StyledWrapper = _ref => {
  let {
    children,
    rtl,
    className
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: `step-card-wraper ${commonStyles} ${rtl ? rtlStyles : ltrStyles} ${className ? className : ""}`
  }, children);
};
const commonStyles = "c10f5gm1";
const rtlStyles = "r1caglhe";
const ltrStyles = "lkijh95";